import request from '@/utils/request'
import api from '../api'

export class Receiving {
  receiptAll(data) {
    return request({
      url: api.receiving.receiptAll,
      method: 'post',
      data
    })
  }
  receiptExport(data) {
    return request({
      url: api.receiving.receiptExport,
      method: 'post',
      data
    })
  }
  receiptCreate(data) {
    return request({
      url: api.receiving.receiptCreate,
      method: 'post',
      data
    })
  }
  receiptOrderAll(data) {
    return request({
      url: api.receiving.receiptOrderAll,
      method: 'post',
      data
    })
  }
  exportLackOrder(data) {
    return request({
      url: api.receiving.exportLackOrder,
      method: 'post',
      data
    })
  }
  exportBadOrder(data) {
    return request({
      url: api.receiving.exportBadOrder,
      method: 'post',
      data
    })
  }
  exportBadDistribute(data) {
    return request({
      url: api.receiving.exportBadDistribute,
      method: 'post',
      data
    })
  }
  uploadOrder(params) {
    return request({
      url: api.receiving.uploadOrder,
      method: 'put',
      params
    })
  }
  orderExport(data) {
    return request({
      url: api.receiving.orderExport,
      method: 'post',
      data
    })
  }
  uploadMaterial(params) {
    return request({
      url: api.receiving.uploadMaterial,
      method: 'put',
      params
    })
  }
  distributeAll(data) {
    return request({
      url: api.receiving.distributeAll,
      method: 'post',
      data
    })
  }
  distributeExport(data) {
    return request({
      url: api.receiving.distributeExport,
      method: 'post',
      data
    })
  }
  distributeDetailAll(data) {
    return request({
      url: api.receiving.distributeDetailAll,
      method: 'post',
      data
    })
  }
  distributeDetailExport(data) {
    return request({
      url: api.receiving.distributeDetailExport,
      method: 'post',
      data
    })
  }
  createDistribute(data) {
    return request({
      url: api.receiving.createDistribute,
      method: 'post',
      data
    })
  }
  saveDistribute(params) {
    return request({
      url: api.receiving.saveDistribute,
      method: 'put',
      params
    })
  }
  orderBatchList(data) {
    return request({
      url: api.receiving.orderBatchList,
      method: 'post',
      data
    })
  }
  batchDownload(params) {
    return request({
      url: api.receiving.batchDownload,
      method: 'put',
      params
    })
  }
  missing(data) {
    return request({
      url: api.receiving.missing,
      method: 'post',
      data
    })
  }
  issued(data) {
    return request({
      url: api.receiving.issued,
      method: 'post',
      data
    })
  }
  exportIssued(data) {
    return request({
      url: api.receiving.exportIssued,
      method: 'post',
      data
    })
  }
  setUploadOrder(params) {
    return request({
      url: api.receiving.setUploadOrder,
      method: 'put',
      params
    })
  }
  setDownloadOrder(params) {
    return request({
      url: api.receiving.setDownloadOrder,
      method: 'post',
      params
    })
  }
  fileDownload(params) {
    return request({
      url: api.receiving.fileDownload,
      method: 'post',
      params
    })
  }
  recordList(data) {
    return request({
      url: api.receiving.recordList,
      method: 'post',
      data
    })
  }
  addRecord(data) {
    return request({
      url: api.receiving.addRecord,
      method: 'post',
      data
    })
  }
  getSupplyModel(params) {
    return request({
      url: api.receiving.getSupplyModel,
      method: 'get',
      params
    })
  }
  getAccountName(data) {
    return request({
      url: api.receiving.getAccountName,
      method: 'post',
      data
    })
  }
}
